(() => {
  if (window.ceikaCountryOfferReady) return;
  window.ceikaCountryOfferReady = true;
  let trigger;
  const open = (dialog, opener) => {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    trigger = opener;
    if (!dialog.open) dialog.showModal();
    dialog.querySelector('input[type="email"]')?.focus();
    return true;
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-ceika-offer-open]');
    if (opener && open(document.getElementById(opener.dataset.ceikaOfferOpen), opener)) event.preventDefault();
    const close = event.target.closest('[data-ceika-offer-close]');
    if (close) close.closest('dialog')?.close();
  });
  const initialize = () => {
    if (document.querySelector('[data-ceika-country-offer]')) document.body.classList.add('promo-banner--show');
    document.querySelectorAll('[data-ceika-offer-dialog]').forEach(dialog => {
      if (dialog.dataset.offerBound) return;
      dialog.dataset.offerBound = 'true';
      dialog.addEventListener('close', () => {
        const returnTarget = trigger?.isConnected && trigger.getClientRects().length ? trigger : [...document.querySelectorAll('[data-ceika-offer-open]')].find(link => link.dataset.ceikaOfferOpen === dialog.id && link.getClientRects().length);
        returnTarget?.focus();
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      if (dialog.querySelector('[data-ceika-offer-result]') || location.hash === '#' + dialog.id) open(dialog);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
